export default __webpack_public_path__ + "static/media/Logo-flc.f80993cd.svg";